import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "id", "aria-label", "role", "menuTriggerId", "closeMenu", "setFocusOnMount", "shouldManageTabIndex", "menuOrientation", "shouldLoopFocus"];
import { forwardRef } from 'react';
import { MenuContextProvider } from '../context/MenuContext';
import { useMenu } from '../hooks/useMenu/useMenu';
import { jsx as _jsx } from "react/jsx-runtime";
export const Menu = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      id,
      'aria-label': ariaLabel,
      role,
      menuTriggerId,
      closeMenu,
      setFocusOnMount,
      shouldManageTabIndex,
      menuOrientation,
      shouldLoopFocus
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    providerProps,
    menuProps
  } = useMenu({
    id,
    ariaLabel,
    role,
    menuTriggerId,
    closeMenu,
    setFocusOnMount,
    shouldManageTabIndex,
    menuOrientation,
    shouldLoopFocus
  });
  return /*#__PURE__*/_jsx(MenuContextProvider, {
    value: providerProps,
    children: /*#__PURE__*/_jsx("ul", Object.assign({
      ref: ref
    }, menuProps, rest, {
      children: children
    }))
  });
});